export const df = { // 默认文案
    'imgUrl': '/country/kenya/luck-draw',

    'drawsTitle': 'Chances Left:',

    'hasPrize': 'Congratulation!',

    'noPrize': 'Oops!Bad Luck',

    'inviteMsg': 'Invitation Code',

    'inviteCode': 'My invitation code',
    
    'copy': 'click on the copy',

    'copySuccess': 'Copy successful',

    'title': 'Prize Records',

    'waitLucky': 'Lucky drawing, please wait a second',

    'prizeRecords': 'Prize Record',

    'prizeRulesTitle': 'Rule Of Activity',

    'numNote': 'How to Get Lucky Draws?',

    'inviteBtnMsg': 'INVITE NOW',

    'modelContent': (count) => `
        <ol>
            <b><li>Apply & Repay a loan</li></b>
            <ul>
            <li>Apply a loan → get 1 draw</li>
            <li>Repay 3 days in advance → get 3 draw</li>
            <li>Repay 2 days in advance  → get ${ count } draw</li>
            <li>Repay 1 day in advance → get 1 draw</li>
            <li>Repay on time  → get 1 draw</li>
            </ul>

            <b><li>Inviting Friends</li></b>
            <ul><li>friends filled in info → get 1 draw</li></ul>
        </ol>
    `,

    'noPrizeModelContent': (_class,link) => `
        <div className=${ _class }>
            <img src='${ link }/no-price.webp' alt="MIB" />
        </div>
    `,

    'hasPrizeModelContent': (_class,link,awardDesc,award) => `
        <div className=${ _class }>
            <div className="name-img" style="
                background-image: url(${ link })
            ">
                <span>${ award.text }</span>
            </div>
            <p className="desc">${ awardDesc }</p>
        </div>
    `,

    'powerPrizeModelContent': (_class,awardId,powerAndCharge,prizeTypeMsg,w=2.8,h=1.15) => `
        <div className='${ _class }' id='l${ awardId }'>
            <p style="text-align:center;margin-top:0;word-break:break-word;">${ prizeTypeMsg }</p>
            <div className="name-img" style="
                width:${w}rem;
                height:${h}rem;
                background-image: url(${ powerAndCharge });
                background-size:100% 100%;margin:0 auto;
            ">
            </div>
        </div>
    `,

    'rulesMain': (activityDate,count) => `
        <h3>Activity Time: <span>${ activityDate || '-' }</span></h3>

        <h3>Do I Have the Qualif ?</h3>
        <p>Any user who has applied a loan have the qualification, even those who failed to get the loan.</p>

        <h3>How to Get Lucky Draws?</h3>
        <ol>
        <b><li>Apply & Repay a loan</li></b>
        <ul>
            <li>Apply a loan → get 1 draw</li>
            <li>Repay 3 days in advance → get 3 draw</li>
            <li>Repay 2 days in advance  → get ${ count } draw</li>
            <li>Repay 1 day in advance → get 1 draw</li>
            <li>Repay on time  → get 1 draw</li>
        </ul>

        <b><li>Inviting Friends</li></b>
        <ul><li>friends filled in info → get 1 draw</li></ul>
        </ol>

        <h3>Effective Period of the Draw&Coupon:</h3>
        <ol>
        <li>The draw is only valid within the day you get it</li>
        <li>The coupon is valid during the whole activity period</li>
        </ol>
        
        <h3>When will I Get the Gift?</h3>
        <ol>
        <li>The coupon will be sent to your account within 24 hours;</li>
        <li>The physical gift will be sent within one week, and specific staff will contact you.</li>
        </ol>

        <h3>Statement</h3>
        <p>The accoding ID number/mobile phone/identity card number are all considered to be the same user. </p>
        <p>If the user / merchant violates the rules (such as false transaction, cheating, malicious cash withdrawal, etc.), we have the right to limit the user account, cancel the illegal transaction and obtain the prize;</p>
        <p>This large turntable rules and prize configuration change with the operation adjustment, the specific page display shall prevail;</p>
    `

}